<template>
  <div :style="`width: ${paperWidth}mm ;height: ${paperHeight}mm;border:0.4mm black solid;margin-bottom:0.6mm`">
    <div style="font-weight: bold;text-align: center;font-size: 4mm;color: black;border-bottom: 0.4mm black solid;height: 20%;" :style="{'line-height': paperHeight*0.2+'mm'}">
      {{ companyName }}
    </div>
    <div style="display: flex;height: 80%;">
      <div
          :style="`display: flex;flex-direction: column;flex: 1;border-right: 0.4mm black solid;text-align: center;`">
        <div :style="`border-bottom:'0.4mm black solid';padding-left: 2mm;line-height: ${classHeight}mm;`"><span
            style="font-weight: 500">{{ name }}</span>
        </div>
      </div>
      <div style="text-align: center;padding: 0.6mm">
        <vue-qr
            :size="1000"
            :margin="0"
            :auto-color="true"
            :dot-scale="1"
            :text="`${codeUrl}?h=${handle}`"
            class="codeImage"
            :style="`width: ${codeWidth}mm;height: ${codeWidth}mm;display: block;margin: 0 auto`"
        />
        <div style="line-height: 4mm;font-size: 12px;font-weight: 500;padding-top: 2mm;">{{ handle }}</div>
      </div>
  </div>
  </div>
</template>
<script>
import VueQr from 'vue-qr'
import {codeUrl} from '@/utils/constant'
export default {
  directives: {

  },
  data(){
    return {
      codeUrl:codeUrl,
      barcode_option: {
        displayValue: false
      },
    }
  },
  components:{VueQr},
  props:{
    handle:{
      type:String,
      default: '86.122.2/123'
    },
    name:{
      type:String,
      default: ''
    },
    companyName:{
        type:String,
        default: ''
    },
    paperWidth:{
        type:Number,
        default: 100
    },
      paperHeight:{
          type:Number,
          default: 100
      },
    codeWidth:{
        type:Number,
        default: 20
    },
      classHeight:{
          type:Number,
          default: 10
      }
  },
  methods:{

  }
}
</script>
<style scoped>
@page {
  size: auto;
  margin: 0mm;
}
</style>
